(function () {
  if (window.__bnkCartGate) return;
  window.__bnkCartGate = true;

  var RE = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;
  var saveTimer = null;
  var lastSaved = null;

  function gates() {
    return document.querySelectorAll('[data-bnk-cartgate]');
  }
  function inputOf(gate) {
    return gate.querySelector('[data-bnk-cartgate-input]');
  }
  function valueOf(gate) {
    var i = inputOf(gate);
    return i ? i.value.trim() : '';
  }
  function ctasOf(gate) {
    var p = gate.parentElement;
    return p ? p.querySelector('.cart__ctas') : null;
  }
  function gateOfCtas(ctas) {
    var p = ctas.parentElement;
    return p ? p.querySelector('[data-bnk-cartgate]') : null;
  }

  function apply(gate) {
    var value = valueOf(gate);
    var valid = RE.test(value);
    var input = inputOf(gate);
    var ctas = ctasOf(gate);
    gate.setAttribute('data-locked', valid ? 'false' : 'true');
    if (ctas) {
      if (valid) ctas.removeAttribute('data-bnk-gatelock');
      else ctas.setAttribute('data-bnk-gatelock', '1');
    }
    if (input) input.setAttribute('aria-invalid', !valid && value.length > 0 ? 'true' : 'false');
    if (valid) {
      var err = gate.querySelector('[data-bnk-cartgate-error]');
      if (err) err.hidden = true;
    }
    return valid;
  }

  function complain(gate) {
    var err = gate.querySelector('[data-bnk-cartgate-error]');
    var input = inputOf(gate);
    if (err) err.hidden = false;
    if (input) {
      input.setAttribute('aria-invalid', 'true');
      try { input.focus({ preventScroll: false }); } catch (e) { input.focus(); }
    }
  }

  function syncOthers(gate, value) {
    gates().forEach(function (other) {
      if (other === gate) return;
      var i = inputOf(other);
      if (i && i.value !== value) {
        i.value = value;
        apply(other);
      }
    });
  }

  function save(gate, done) {
    var value = valueOf(gate);
    if (!RE.test(value)) {
      if (done) done();
      return;
    }
    if (value === lastSaved) {
      if (done) done();
      return;
    }
    lastSaved = value;
    var url = gate.getAttribute('data-update-url') || '/cart/update.js';
    var attrs = {};
    attrs[gate.getAttribute('data-attr-name') || 'E-mailadres voor levering'] = value;
    try {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs }),
        keepalive: true
      })
        .then(function () { if (done) done(); })
        .catch(function () {
          lastSaved = null;
          if (done) done();
        });
    } catch (e) {
      lastSaved = null;
      if (done) done();
    }
  }

  /* Het formulier naar /cart vult het contactveld van de checkout niet voor; de
     checkout-URL doet dat wel. Daarom nemen we de gewone afrekenknop over: eerst het
     kenmerk opslaan, dan naar de checkout met het adres in de URL. */
  function goToCheckout(gate) {
    var value = valueOf(gate);
    var root = gate.getAttribute('data-root-url') || '/';
    if (root === '/') root = '';
    var target = root + '/checkout?checkout%5Bemail%5D=' + encodeURIComponent(value);
    var navigated = false;
    var go = function () {
      if (navigated) return;
      navigated = true;
      window.location.assign(target);
    };
    setTimeout(go, 1500);
    save(gate, go);
  }

  document.addEventListener('input', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var gate = target.closest('[data-bnk-cartgate]');
    if (!gate || !target.matches('[data-bnk-cartgate-input]')) return;
    apply(gate);
    syncOthers(gate, valueOf(gate));
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () { save(gate); }, 350);
  });

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var gate = target.closest('[data-bnk-cartgate]');
      if (!gate || !target.matches('[data-bnk-cartgate-input]')) return;
      if (apply(gate)) save(gate);
    },
    true
  );

  document.addEventListener(
    'pointerdown',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var ctas = target.closest('.cart__ctas');
      if (!ctas) return;
      var gate = gateOfCtas(ctas);
      if (gate && apply(gate)) save(gate);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var ctas = target.closest('.cart__ctas');
      if (!ctas) return;
      var gate = gateOfCtas(ctas);
      if (!gate) return;

      var shield = target.closest('[data-bnk-cartgate-shield]');
      var checkoutButton = target.closest('.cart__checkout-button');
      if (!shield && !checkoutButton) return;

      if (!apply(gate)) {
        event.preventDefault();
        event.stopPropagation();
        complain(gate);
        return;
      }

      if (checkoutButton) {
        event.preventDefault();
        event.stopPropagation();
        goToCheckout(gate);
      }
    },
    true
  );

  function init() {
    gates().forEach(function (gate) {
      apply(gate);
      var err = gate.querySelector('[data-bnk-cartgate-error]');
      if (err) err.hidden = true;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);

  /* De winkelwagenlade en de winkelwagensectie worden door het thema opnieuw opgehaald via de
     Section Rendering API en als HTML ingevoegd. Een <script> in ingevoegde HTML draait niet,
     daarom staat dit bestand als thema-asset op elke pagina. Deze waarnemer zorgt dat een poort
     die later binnenkomt meteen de juiste toestand krijgt, en dat een reeds ingevuld adres na
     een hertekening niet als leeg wordt gelezen. */
  var pending = null;
  var observer = new MutationObserver(function (records) {
    var relevant = false;
    for (var i = 0; i < records.length && !relevant; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (
          (node.matches && node.matches('[data-bnk-cartgate], .cart__ctas')) ||
          (node.querySelector && node.querySelector('[data-bnk-cartgate], .cart__ctas'))
        ) {
          relevant = true;
          break;
        }
      }
    }
    if (!relevant) return;
    clearTimeout(pending);
    pending = setTimeout(init, 60);
  });

  function watch() {
    if (document.body) observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) watch();
  else document.addEventListener('DOMContentLoaded', watch);
})();
